import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Box, Divider } from "@mui/material";

import { STRUCTURE_TYPES } from "../../../constant/types";
import getStructureTreeData from "../../../helpers/getStructureTreeDataStructure";
import { WorkspaceList } from "../WorkspaceList";
import SearchInput from "../WorkspaceSelectorSearchInput";
import OrganizeWorkspacesLink from "../OrganizeWorkspacesLink";
import CreateWorkspaceButton from "./CreateWorkspaceButton";

import WorkspaceWizardModal from "../../Administration/Sites/WorkspaceWizardModal";

const WorkspaceContainer = ({
  onCreateWorkspace,
  onWorkspaceSelected,
  showCreateWorkspaceButton,
  workspaces,
}) => {
  const [structureTree, setStructureTree] = useState({});
  const [openWizard, setOpenWizard] = useState(false);

  const createStructureTree = (workspaceArray) => {
    return getStructureTreeData({
      structures: workspaceArray,
    });
  };

  const handleSearchInputChange = (query) => {
    let filteredTree = {};

    if (!query) {
      const tree = createStructureTree(workspaces);
      return setStructureTree(tree);
    }

    const keys = Object.keys(structureTree);

    keys.forEach((x) => {
      if (
        structureTree[x].name.toLowerCase().includes(query.toLowerCase()) &&
        structureTree[x].type !== STRUCTURE_TYPES.FOLDER
      ) {
        const tempValues = { ...structureTree[x], isRoot: true };
        const found = { [x]: tempValues };
        filteredTree = { ...filteredTree, ...found };
      }
    });

    setStructureTree(filteredTree);
  };

  useEffect(() => {
    const tree = createStructureTree(workspaces);
    setStructureTree(tree);
  }, [workspaces]);

  return (
    <Box>
      <SearchInput onChange={handleSearchInputChange} />
      <Divider />
      <WorkspaceList
        headerLabel={<FormattedMessage id="workspace.my" />}
        onClick={(site) => onWorkspaceSelected?.(site.siteId)}
        structureTree={structureTree}
      />
      <Box sx={{ textAlign: "right", p: "7px 10px" }}>
        <OrganizeWorkspacesLink />
        {showCreateWorkspaceButton && (
          <CreateWorkspaceButton onClick={() => setOpenWizard(true)} />
        )}
      </Box>
      <WorkspaceWizardModal
        open={openWizard}
        onClose={() => setOpenWizard(false)}
        onCreated={(ws) => {
          setOpenWizard(false);
          onCreateWorkspace?.(ws); // bubbla upp om du vill hantera ny arbetsyta högre upp
        }}
      />
    </Box>
  );
};

WorkspaceContainer.propTypes = {
  onCreateWorkspace: PropTypes.func,
  onWorkspaceSelected: PropTypes.func.isRequired,
  showCreateWorkspaceButton: PropTypes.bool,
  workspaces: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      name: PropTypes.string,
    }).isRequired
  ).isRequired,
};

export default WorkspaceContainer;
